module.exports = __webpack_public_path__ + "static/media/down-arrow.f665222d.svg";